import { useMemo } from 'react';
import { useSnapshot } from 'valtio';
import { capturePosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import store from '../../store';
import { useUtilitiesPageRedesignEnabled } from '../../useUtilitiesPageRedesignEnabled';
import Drawer from '../Drawer';
import { stepConfig } from './common';

export default function RequestData() {
  const { formState, project } = useSnapshot(store) as typeof store;
  const isPageRedesignEnabled = useUtilitiesPageRedesignEnabled();

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  const config = useMemo(() => {
    const { step } = formState;
    if (step && project) {
      capturePosthogEvent(POSTHOG_EVENTS.civilsearchRequestDataViewed, {
        project_id: project.id,
        step,
      });
    }

    return stepConfig[step] || stepConfig[1];
  }, [formState]);

  const title = isPageRedesignEnabled && config === stepConfig[0] ? 'Request Utility Research' : config.title;

  return (
    <Drawer title={title}>
      <config.content />
    </Drawer>
  );
}
